/**
 * The permission strings `server/internal/treasury/sweep_permissions.go` declares.
 *
 *  - `treasury.sweep.read` - structures, their participants, simulations and history.
 *  - `treasury.sweep.manage` - prepare, edit, delete a draft, suspend, and (as a SECOND
 *    person, enforced in the service) activate a structure.
 *  - `treasury.sweep.execute` - simulate a sweep and execute a simulation.
 *
 * The pickers of the editor read other modules' lists under their own permissions
 * (bank accounts, operating calendars, intercompany instruments); the server decides.
 */

export const SWEEP_PERMISSIONS = {
  read: 'treasury.sweep.read',
  manage: 'treasury.sweep.manage',
  execute: 'treasury.sweep.execute',
} as const
